import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';
import { DeleteType } from 'components/DeleteHubModal/types';

export const deleteHubById = async (info: {
  hubId: number;
  level: number;
  deleteType: DeleteType | null;
  targetHubId: number | null;
}) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.put(
    `/hub_delete/${info.hubId}/`,
    {
      level: info.level,
      traps_action: info.deleteType ? info.deleteType : DeleteType.DELETE,
      target_hub_id: info.targetHubId,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data.data as any;
};
